import { ArrowDown } from './ArrowDown';
import { ArrowUp } from './ArrowUp';
import { Cross } from './Cross';
import { PingingVitalLogo } from './PingingVitalLogo';
import { VitalLogo } from './VitalLogo';
export default {
    ArrowDown: ArrowDown,
    ArrowUp: ArrowUp,
    CrossIcon: Cross,
    PingingVitalIcon: PingingVitalLogo,
    VitalIcon: VitalLogo,
};
